// extracted by mini-css-extract-plugin
module.exports = {"ContactUs":"ContactUs_ContactUs__11Fod","ContactImg":"ContactUs_ContactImg__2sjqG","ContactImgAnimation":"ContactUs_ContactImgAnimation__1xdm1","Right":"ContactUs_Right__13PZZ"};